// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-split {
  flex: 1 1;
  height: 100%;
  position: relative;
  width: 100%;
}
.react-split__pane {
  height: 100%;
  position: absolute;
  white-space: normal;
  width: 100%;
  overflow: hidden;
}
.react-split__sash {
  height: 100%;
  position: absolute;
  top: 0;
  transition: background-color 0.1s;
  width: 100%;
  z-index: 2;
}
.react-split__sash--disabled {
  pointer-events: none;
}
.react-split__sash--vertical {
  cursor: col-resize;
}
.react-split__sash--horizontal {
  cursor: row-resize;
}
.react-split__sash-content {
  width: 100%;
  height: 100%;
}
.react-split__sash-content--active {
  background-color: #175ede;
}
.react-split--dragging.react-split--vertical {
  cursor: col-resize;
}
.react-split--dragging.react-split--horizontal {
  cursor: row-resize;
}

body.react-split--disabled {
  -webkit-user-select: none;
          user-select: none;
}

.split-sash-content {
  width: 100%;
  height: 100%;
}
.split-sash-content.split-sash-content-vscode.split-sash-content-active {
  background-color: #175ede;
}`, "",{"version":3,"sources":["webpack://./node_modules/split-pane-react/esm/themes/default.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,iCAAiC;EACjC,WAAW;EACX,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".react-split {\n  flex: 1;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.react-split__pane {\n  height: 100%;\n  position: absolute;\n  white-space: normal;\n  width: 100%;\n  overflow: hidden;\n}\n.react-split__sash {\n  height: 100%;\n  position: absolute;\n  top: 0;\n  transition: background-color 0.1s;\n  width: 100%;\n  z-index: 2;\n}\n.react-split__sash--disabled {\n  pointer-events: none;\n}\n.react-split__sash--vertical {\n  cursor: col-resize;\n}\n.react-split__sash--horizontal {\n  cursor: row-resize;\n}\n.react-split__sash-content {\n  width: 100%;\n  height: 100%;\n}\n.react-split__sash-content--active {\n  background-color: #175ede;\n}\n.react-split--dragging.react-split--vertical {\n  cursor: col-resize;\n}\n.react-split--dragging.react-split--horizontal {\n  cursor: row-resize;\n}\n\nbody.react-split--disabled {\n  user-select: none;\n}\n\n.split-sash-content {\n  width: 100%;\n  height: 100%;\n}\n.split-sash-content.split-sash-content-vscode.split-sash-content-active {\n  background-color: #175ede;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
